module.exports = __webpack_public_path__ + "0f324796a02a1c401514c01dfc930081.svg";